import React from 'react';
import clsx from 'clsx';
import { MdDeleteOutline, MdNotificationsNone } from 'react-icons/md';
import { IMailReminderInfo } from '@models/document/actionsExecution/IMailReminderModel';
import { formatCreated, formatDelivery } from './reminderTime';

interface IRemindersListProps {
    reminders: IMailReminderInfo[];
    /** Удаление напоминания; успех/ошибку и состояние списка ведёт родитель. */
    onDelete: (reminder: IMailReminderInfo) => void;
}

/**
 * Список назначенных напоминаний в языке блока аттачей: строка-карточка с
 * колокольчиком, сообщением и чипом времени доставки (точка кодирует близость
 * срока). Заменяет DevExtreme-грид — модалка больше не тянет devextreme.
 */
const RemindersList: React.FC<IRemindersListProps> = ({ reminders, onDelete }: IRemindersListProps) => {
    if (reminders.length === 0) {
        return (
            <div className="reminders-list__empty">
                <b>Напоминаний пока нет</b>
                Заполните текст и время доставки выше — напоминание появится в этом списке.
            </div>
        );
    }

    return (
        <div className="reminders-list" role="list">
            {reminders.map((reminder) => {
                const delivery = formatDelivery(reminder.deliveryDateTime);
                return (
                    <div key={reminder.id} className="reminders-list__row" role="listitem">
                        <div className="reminders-list__icon" aria-hidden="true">
                            <MdNotificationsNone size={18} />
                        </div>
                        <div className="reminders-list__main">
                            <div
                                className={clsx('reminders-list__message', {
                                    'reminders-list__message--empty': !reminder.message,
                                })}
                                title={reminder.message || undefined}
                            >
                                {reminder.message || 'Без сообщения'}
                            </div>
                            <div className="reminders-list__created">{formatCreated(reminder.creationDateTime)}</div>
                        </div>
                        <span className={clsx('reminders-list__when', `reminders-list__when--${delivery.tone}`)}>
                            {delivery.label}
                            {delivery.sub && <small>{delivery.sub}</small>}
                        </span>
                        <button
                            type="button"
                            className="reminders-list__delete"
                            title="Удалить напоминание"
                            aria-label="Удалить напоминание"
                            onClick={() => onDelete(reminder)}
                        >
                            <MdDeleteOutline size={16} />
                        </button>
                    </div>
                );
            })}
        </div>
    );
};

export default RemindersList;
